const Services = () => {
  return (
    <div className="services">
        <h2>Here's what I can do for you:</h2>
        <ul>
            <li>Responsive and mobile design</li>
            <li>React.js development</li>
            <li>HTML5 & CSS3 development</li>
            <li>Cross-browser development</li>
            <li>Maintenace and optimisation services</li>
        </ul>
    </div>
  )
}

export default Services